import React from "react";
import { Box, Typography, Grid, Card, Button } from "@mui/material";

const UnlockScreen = () => {
  const coinOptions = [
    { coins: "10", bonus: "", price: "₹95.00" },
    { coins: "50 + 5", bonus: "+10% Coins", price: "₹480.00" },
    { coins: "100 + 15", bonus: "+15% Coins", price: "₹950.00" },
    { coins: "200 + 100", bonus: "+50% Coins", price: "₹1,950.00" },
  ];

  const membershipOptions = [
    {
      title: "Membership ₹790.00 /week",
      description: "Unlimited access to all series for 1 week",
      details: "Auto renew • Cancel anytime",
    },
    {
      title: "Membership ₹9,800.00 /year",
      description: "Unlimited access to all series for 1 year",
      details: "Auto renew • Cancel anytime",
    },
  ];

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        // height: "50vh",
        backgroundColor: "#1c1c1e",
        color: "#fff",
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
        boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.3)",
        padding: "16px",
        overflowY: "auto",
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", marginBottom: "16px", textAlign: "center" }}
      >
        Unlock Video
      </Typography>


      {/* Membership Options */}
      {membershipOptions.map((membership, index) => (
        <Box
          key={index}
          sx={{
            border: "1px solid #444",
            borderRadius: "8px",
            padding: "12px",
            marginBottom: "8px",
          }}
        >
          <Typography sx={{ fontWeight: "bold", color: "#ffcc00" }}>
            {membership.title}
          </Typography>
          <Typography sx={{ fontSize: "14px", color: "#fff" }}>
            {membership.description}
          </Typography>
          <Typography sx={{ fontSize: "12px", color: "#888" }}>
            {membership.details}
          </Typography>
        </Box>
      ))}

      <Button
        variant="contained"
        sx={{
          marginTop: "8px",
          backgroundColor: "#FF4500",
          color: "#fff",
          padding: "8px 16px",
          borderRadius: "24px",
          fontSize: "14px",
          display: "block",
          width: "100%",
        }}
        onClick={() => alert("Proceed to unlock")}
      >
        Close
      </Button>
    </Box>
  );
};

export default UnlockScreen;